"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _auth = require("@/utils/auth");
var _userLogin = _interopRequireDefault(require("@/views/commonData/home/components/userLogin.vue"));
var _forgetPassWord = _interopRequireDefault(require("@/views/commonData/home/components/forgetPassWord.vue"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    userLogin: _userLogin.default,
    forgetPassWord: _forgetPassWord.default
  },
  data: function data() {
    return {
      hoveredTabBox: null,
      currentIndexQuery: null,
      hoveredTab: null,
      currentIndex: null,
      isEditPassword: false,
      imgCodeList: [{
        url: require("../../assets/img/weixinpublic.jpg"),
        text: '扫描关注微信公众号'
      }, {
        url: require("../../assets/img/ios.jpg"),
        text: '下载IOS小程序'
      }, {
        url: require("../../assets/img/weixin.jpg"),
        text: '下载安卓小程序'
      }],
      navTabList: [],
      tabList: [{
        name: '船期查询'
      }, {
        name: '船舶动态&汇率'
      }, {
        name: '货物跟踪'
      }],
      navList: [{
        nameEn: 'Home',
        nameZh: '首页',
        path: '/home'
      }, {
        nameEn: 'Schedule',
        nameZh: '船期',
        path: '/basicInfo/product'
      }, {
        nameEn: 'Booking',
        nameZh: '订舱',
        path: '/bookingSpace'
      }, {
        nameEn: 'Information',
        nameZh: '信息查询',
        path: '/basicInfo/solution'
      }, {
        nameEn: 'Inbound',
        nameZh: '进口',
        path: '/basicInfo/contact'
      }, {
        nameEn: 'Equipment',
        nameZh: '箱管',
        path: '/basicInfo/service'
      }, {
        nameEn: 'Contact Us',
        nameZh: '联系我们',
        path: '/basicInfo/contact'
      }],
      list: {
        1: [{
          name: this.$t('home.vesselOne'),
          path: '/topMenu/voyagePlanSearch'
        }, {
          name: this.$t('home.vesselTwo'),
          path: '/topMenu/vesselMovementSearch'
        }, {
          name: this.$t('home.vesselThree'),
          path: '/topMenu/vesselInfo',
          'iconAuth': false,
          'iconLogin': true
        }],
        2: [{
          name: this.$t('home.controlOne'),
          path: '/bookingSpace/bookingSpaceList',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlTwo'),
          path: '/bookingSpace/bookingSpaceMy',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlThree'),
          path: '/bookingSpace/bookingJapan',
          'iconAuth': true,
          'iconLogin': true
        },
        // {
        //   name: this.$t('home.controlFour'),
        //   path: '/bookingSpace/bookingHistoryJp',
        //   'iconAuth': true,
        //   'iconLogin': true
        // },
        {
          name: this.$t('home.controlFive'),
          path: '/topMenu/vgmApply',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.controlSix'),
          path: '/bookingSpace/dangerousDeclaration',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlSeven'),
          path: '/bookingSpace/newManifestEDI',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlEight'),
          path: '/bookingSpace/ediFeedBack',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlNine'),
          path: '/bookingSpace/myBookingTemplate',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.exportCostSlipUpload'),
          path: '/settlementManagement/exportCostSlipUpload',
          'iconAuth': true,
          'iconLogin': true
        }],
        3: [{
          name: this.$t('home.infoOne'),
          path: '/topMenu/cargoTrack',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoTwo'),
          path: '/topMenu/release',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoThree'),
          path: '/topMenu/dangerCargoSpecContainer',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoFour'),
          path: '/topMenu/surchargeAndMiscellaneous',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoFive'),
          path: '/topMenu/carbonCalculator',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoSix'),
          path: '/topMenu/searchFile',
          'iconAuth': false,
          'iconLogin': false
        }],
        4: [{
          name: this.$t('home.importTwo'),
          path: '/topMenu/cargoInfoSearch',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.importThree'),
          path: '/import/blExchangeAppointment',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFour'),
          path: '/import/appointmentHistory',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFive'),
          path: '/import/blExchangeAppointmentSh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importSix'),
          path: '/import/appointmentHistorySh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.appointmentHistorySh'),
          path: '/settlementManagement/importBillUpload',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importOne'),
          path: '/topMenu/delivery',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }],
        5: [{
          name: this.$t('home.containerOne'),
          path: '/topMenu/equipmentFee',
          'iconAuth': false,
          'iconLogin': false,
          'isOpen': true
        }, {
          name: this.$t('home.containerTwo'),
          path: '/topMenu/containerInfo',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.containerThree'),
          path: '/topMenu/tariffs',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.containerFour'),
          path: '/topMenu/demurrageCalculation',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }],
        6: [{
          name: this.$t('home.suggest'),
          path: '/topMenu/issueApply',
          'iconLogin': true,
          'iconAuth': false
        }, {
          name: this.$t('home.branch'),
          path: '/portContacts',
          'isOpen': true,
          'iconAuth': false,
          'iconLogin': false
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  watch: {
    $route: {
      handler: function handler(route) {
        this.queryPath = route.path;
        this.handleIsAddTop();
        console.log('query8889998', this.queryPath);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // this.handleGetData()
  },
  methods: {
    handleHelp: function handleHelp() {
      var url = "/#/helpDocuments";
      window.open(url);
    },
    handleClick: function handleClick(index) {
      if (index === 0) {
        this.$router.push({
          path: '/home'
        });
      }
    },
    handleForgetPassword: function handleForgetPassword(data) {
      this.isEditPassword = data;
      this.$refs.forgetPassWord.forgetDialogVisible = true;
    },
    handleGoto: function handleGoto(item) {
      console.log(item.path);
      this.$router.push({
        path: item.path
      });
    },
    handleSetLanguage: function handleSetLanguage(lang) {
      var _this = this;
      this.hoveredTab = null;
      /* 刷新 */
      var view = this.$route;
      this.$store.dispatch('tagsView/delCachedView', view).then(function () {
        var fullPath = view.fullPath;
        _this.$nextTick(function () {
          console.log('fullPath', fullPath);
          _this.$router.replace({
            path: '/redirect' + fullPath
          });
          _this.$i18n.locale = lang;
          _this.$store.dispatch('app/setLanguage', lang);
          // if(!this.noSuccessTip){
          //   this.$message({
          //     message: this.language === 'zh' ? '语言切换成功' : 'Switch Language Success',
          //     type: 'success'
          //   })
          // }
        });
      });
    },
    handleGoLogin: function handleGoLogin() {
      this.$refs.userLogin.dialogVisible = true;
    },
    handleToUserCenter: function handleToUserCenter() {
      this.$router.push({
        path: '/userCenter/userCenter'
      });
    },
    hoverTabLeave: function hoverTabLeave() {
      this.hoveredTab = null;
      this.navTabList = [];
      this.currentIndex = null;
    },
    handleClickNav: function handleClickNav(item, index) {
      console.log('item', item);
      this.currentIndex = index;
      if (!item.iconLogin) {
        var url = "/#".concat(item.path);
        window.open(url);
      } else if ((0, _auth.getToken)() && item.isOpen) {
        var _url = "/#".concat(item.path);
        window.open(_url);
      } else if ((0, _auth.getToken)() && item.path == '/topMenu/vesselInfo') {
        var _url2 = "/#".concat(item.path);
        window.open(_url2);
      } else if (!(0, _auth.getToken)() && item.path == '/topMenu/vesselInfo') {
        this.$message({
          message: this.$t('home.noLoginMessage'),
          type: 'warning'
        });
      } else {
        this.$router.push({
          path: item.path
        });
      }
      this.currentIndexQuery = null;
    },
    handleLogOut: function handleLogOut() {
      var _this2 = this;
      this.$confirm(this.$t('home.logOutMessage'), this.$t('confirmMsg.title'), {
        confirmButtonText: this.$t('home.sumit'),
        cancelButtonText: this.$t('home.cancelButton'),
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch('user/logoutAuth');
        _this2.$router.push({
          path: '/home'
        });
      }).catch(function () {});
    },
    handleIsAddTop: function handleIsAddTop() {
      for (var key in this.list) {
        if (this.list.hasOwnProperty(key)) {
          var items = this.list[key];
          var _iterator = (0, _createForOfIteratorHelper2.default)(items),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (item.path === this.queryPath) {
                console.log('key--------------', key);
                return this.hoveredTabBox = key;
              } else {
                this.hoveredTabBox = null;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      return null; // 如果未找到匹配的路径，返回null
    },
    handleGetData: function handleGetData() {
      this.list = {
        1: [{
          name: this.$t('home.vesselOne'),
          path: '/topMenu/voyagePlanSearch'
        }, {
          name: this.$t('home.vesselTwo'),
          path: '/topMenu/vesselMovementSearch'
        }, {
          name: this.$t('home.vesselThree'),
          path: '/topMenu/vesselInfo',
          'iconAuth': false,
          'iconLogin': true
        }],
        2: [{
          name: this.$t('home.controlOne'),
          path: '/bookingSpace/bookingSpaceList',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlTwo'),
          path: '/bookingSpace/bookingSpaceMy',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlThree'),
          path: '/bookingSpace/bookingJapan',
          'iconAuth': true,
          'iconLogin': true
        },
        // {
        //   name: this.$t('home.controlFour'),
        //   path: '/bookingSpace/bookingHistoryJp',
        //   'iconAuth': true,
        //   'iconLogin': true
        // },
        {
          name: this.$t('home.controlFive'),
          path: '/topMenu/vgmApply',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.controlSix'),
          path: '/bookingSpace/dangerousDeclaration',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlSeven'),
          path: '/bookingSpace/newManifestEDI',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlEight'),
          path: '/bookingSpace/ediFeedBack',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.controlNine'),
          path: '/bookingSpace/myBookingTemplate',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.exportCostSlipUpload'),
          path: '/settlementManagement/exportCostSlipUpload',
          'iconAuth': true,
          'iconLogin': true
        }],
        3: [{
          name: this.$t('home.infoOne'),
          path: '/topMenu/cargoTrack',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoTwo'),
          path: '/topMenu/release',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoThree'),
          path: '/topMenu/dangerCargoSpecContainer',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.infoFour'),
          path: '/topMenu/surchargeAndMiscellaneous',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoFive'),
          path: '/topMenu/carbonCalculator',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.infoSix'),
          path: '/topMenu/searchFile',
          'iconAuth': false,
          'iconLogin': false
        }],
        4: [{
          name: this.$t('home.importTwo'),
          path: '/topMenu/cargoInfoSearch',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.importThree'),
          path: '/import/blExchangeAppointment',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFour'),
          path: '/import/appointmentHistory',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importFive'),
          path: '/import/blExchangeAppointmentSh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importSix'),
          path: '/import/appointmentHistorySh',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.appointmentHistorySh'),
          path: '/settlementManagement/importBillUpload',
          'iconAuth': true,
          'iconLogin': true
        }, {
          name: this.$t('home.importOne'),
          path: '/topMenu/delivery',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }],
        5: [{
          name: this.$t('home.containerOne'),
          path: '/topMenu/equipmentFee',
          'iconAuth': false,
          'iconLogin': false,
          'isOpen': true
        }, {
          name: this.$t('home.containerTwo'),
          path: '/topMenu/containerInfo',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }, {
          name: this.$t('home.containerThree'),
          path: '/topMenu/tariffs',
          'iconAuth': false,
          'iconLogin': false
        }, {
          name: this.$t('home.containerFour'),
          path: '/topMenu/demurrageCalculation',
          'iconAuth': false,
          'iconLogin': true,
          'isOpen': true
        }],
        6: [{
          name: this.$t('home.suggest'),
          path: '/topMenu/issueApply',
          'iconLogin': true,
          'iconAuth': false
        }, {
          name: this.$t('home.branch'),
          path: '/portContacts',
          'isOpen': true,
          'iconAuth': false,
          'iconLogin': false
        }]
      };
    },
    selectSecondTab: function selectSecondTab(index) {
      if (index === 4) {
        this.navTabList = this.list[4];
      }
      if (index === 2) {
        this.navTabList = this.list[2];
      }
      if (index === 3) {
        this.navTabList = this.list[3];
      }
      if (index === 5) {
        this.navTabList = this.list[5];
      }
      if (index === 1) {
        this.navTabList = this.list[1];
      }
      if (index === 6) {
        this.navTabList = this.list[6];
      }
    },
    adjustSecondTabPosition: function adjustSecondTabPosition(index) {
      // 获取当前鼠标移动到的container-box-item元素
      var containerBoxItem = this.$refs.containerBoxItem[index];
      var rect = containerBoxItem.getBoundingClientRect();

      // 获取container-list-tab元素
      var containerListTab = this.$refs.containerListTab;

      // 设置container-list-tab的位置
      // containerListTab.style.top = `${rect.bottom}px`;
      var left = rect.left < 425 ? 425 : rect.left;
      containerListTab.style.left = "".concat(left, "px");

      // 获取container-list-tab的尺寸
      var tabRect = containerListTab.getBoundingClientRect();

      // 获取窗口的宽度
      var windowWidth = window.innerWidth;

      // 检查container-list-tab是否超出了屏幕的宽度
      if (tabRect.right > windowWidth) {
        // 调整container-list-tab的left属性，使其完全在屏幕内
        containerListTab.style.left = "".concat(windowWidth - tabRect.width, "px");
      }
    },
    hoverTab: function hoverTab(index) {
      this.hoveredTab = null;
      this.handleGetData();
      this.hoveredTab = index;
      this.selectSecondTab(index);
      this.adjustSecondTabPosition(index);
      for (var ele = 0; ele < this.navTabList.length; ele++) {
        var item = this.navTabList[ele];
        if (this.queryPath === item.path) {
          return this.currentIndexQuery = ele;
        } else {
          this.currentIndexQuery = null;
        }
      }
    }
  }
};